var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs)?_c('div',{staticClass:"ui-breadcrumbs"},[_c('div',{domProps:{"innerHTML":_vm._s(this.breadcrumbs.join(' / '))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }